<template>
    <SideBarMainInput
        v-model="formData.name"
        class="max-mob:px-4"
        :loading="detailVoipShieldStore.loading"
        :readonly="!editVoipShieldPermission"
        @onBlur="updateVoipShield"
    />

    <div class="text-gray-280 max-mob:px-4 text-xs">
        Block VoIP callers to prevent fraud traffic, 0.01$ per call
    </div>
</template>

<script setup>
import { reactive, computed, watch } from 'vue'

import SideBarMainInput from '@/components/inputs/SideBarMainInput.vue'

import { useDetailVoipShieldStore } from '@/store/call-tracking/suppressionList/detailVoipShieldStore'
import { usePermissionsStore } from '@/store/permissionsStore'

const detailVoipShieldStore = useDetailVoipShieldStore()
const permissionsStore = usePermissionsStore()

const formData = reactive({
    name: null,
})

const editVoipShieldPermission = computed(() => permissionsStore.permissions.voipShield.edit)

function parseData({ name }) {
    formData.name = name
}

function updateVoipShield() {
    detailVoipShieldStore.goToUpdateVoipShield(formData)
}

watch(() => detailVoipShieldStore.formData, (formData) => {
    parseData(formData)
}, { deep: true, immediate: true })
</script>
